<template lang='pug'>
  div
    v-text-field.mb-2(
      label='User-Agent Override'
      placeholder='Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/88.0.4324.182 Bionic'
      hint='Setting a value here to override the browser User-Agent. Leave blank to use the default User-Agent.'
      :value='value'
      @input='v => $emit("input", v)'
      type='text')

</template>

<script>
export default {
  name: 'BionicMetricsUserAgent',
  props: {
    value: {
      type: String
    }
  }
};
</script>

<style scoped>
</style>
